export default "__VITE_ASSET__q9G3kw58__"